import ReactGA from 'react-ga4';

const TRACKING_ID = 'G-3RSPC7WRCV';

// Wrap analytics initialization in requestIdleCallback or window.onload for deferred loading
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(() => {
    ReactGA.initialize(TRACKING_ID);
  });
} else {
  window.onload = () => {
    ReactGA.initialize(TRACKING_ID);
  };
}

export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (category, action, label = '') => {
  ReactGA.event({
    category,
    action,
    label
  });
};
